import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
  className?: string;
}

export default function NewsCard({ item, className = "" }: NewsCardProps) {
  const to = item.linkTitleId
    ? `/detail/${item.linkTitleId}`
    : item.linkSpecialId
      ? `/special/${item.linkSpecialId}`
      : "/special";

  return (
    <Link
      to={to}
      className={`group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - WW我的快乐在哪里影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-1 text-xs font-medium text-background-50">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line" aria-hidden="true" />
            {item.date}
          </span>
          <span className="inline-flex items-center gap-1 text-primary-600">
            阅读全文
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  );
}